import {Type} from '@angular/core';

export interface ComponentCatalog {
  name: string;
  group: string;
}

export interface ComponentCatalogComponent extends ComponentCatalog {
  type: Type<any>;
  id: string;
}

const components: ComponentCatalogComponent[] = [];

export function ComponentCatalog(options: ComponentCatalog) {
  return function (type: any) {
    components.push({ type, ...options, id: '' });
  };
}

export function getComponentCatalogComponents(): ComponentCatalogComponent[] {
  return [...components];
}
